import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Table } from "primeng/table";
import { FolhaPagamentosService } from "../../../services/folha-pagamentos.service";
import { SpinnerService } from "../../../services/spinner.service";
import { ToastService } from "../../../services/toast.service";
import { SeveridadeToast } from "../../../models/enums/severidade-toast.enum";
import { FormataDataHelper } from "../../../helpers/formata-data.helper";
import { JwtHelper } from "../../../helpers/jwtDecode.helper";

@Component({
    selector: 'app-folha-pagamentos-editar',
    templateUrl: './folha-pagamentos-editar.component.html',
    styleUrls: ['./folha-pagamentos-editar.component.scss']
})
export class FolhaPagamentosEditarComponent implements OnInit {

    @ViewChild('dt') dt: Table | undefined;
    @Output() tituloChange = new EventEmitter<string>();
    @Output() iconeChange = new EventEmitter<string>();

    editarPagamento: FormGroup = new FormGroup({
        id: new FormControl(''),
        pa: new FormControl('', Validators.required),
        valor: new FormControl(0, Validators.required),
        usuarioId: new FormControl(null),
    });

    idPagamento: any;

    constructor(
        private route: ActivatedRoute,
        private folhaPagamentosService: FolhaPagamentosService,
        private spinnerService: SpinnerService,
        private toastService: ToastService,
        private router: Router,
        private jwtHelper: JwtHelper,
    ) {

    }

    ngOnInit(): void {
        this.tituloChange.emit('Editar de Folha de pagamentos');
        this.iconeChange.emit('pi pi-pencil');

        this.route.params.subscribe(params => { this.editarPagamento.get('id').setValue(params['id']) });
        this.route.params.subscribe(params => { this.editarPagamento.get('pa').setValue(+params['pa']) });
        this.route.params.subscribe(params => { this.editarPagamento.get('valor').setValue(+params['valor'] ? +params['valor'] : 0) });
        this.editarPagamento.get('usuarioId').setValue(this.jwtHelper.getUserIdFromToken());
    }

    formatCompetencia(pa: number | undefined): string {
        return FormataDataHelper.formatarCompetencia(pa);
    }

    onSubmit(): void {
        this.spinnerService.show('Editando pagamento...');
        this.folhaPagamentosService.updatePlanoDeContas(this.editarPagamento.get('id').getRawValue(), this.editarPagamento.getRawValue()).subscribe({
            next: (res) => {
                this.toastService.setMensagemToast('Pagamento editada com sucesso!', SeveridadeToast.Success);
                this.router.navigate(['folha-pagamentos']);
                this.spinnerService.hide();
            },
            error: (e) => {
                this.toastService.setMensagemToast(`Erro ao editar pagamento: ${e.error}`, SeveridadeToast.Error);
                this.spinnerService.hide();
            }
        })
    }

    onCancel(): void {
        this.router.navigate(['folha-pagamentos']);
    }
}